import * as React from "react";
import { isEmpty } from "lodash-es";
import { hasInvestorProfiles } from "api/events/event.mapper";
import { useNavigate, useParams, Route, Routes } from "react-router";
import { EventNavigation } from "components/Event/Corporate/EventNavigation";
import { useGetEventDetailQuery } from "queries/useGetEventDetailQuery";
import { EventCorporateRoadshowTab } from "components/Event/Corporate/Tabs/EventCorporateRoadshowTab";
import { ROUTES } from "common/routes";
import { EventCorporateContactsTab } from "components/Event/Corporate/Tabs/EventCorporateContactsTab";
import { EventCorporateInvestorProfilesTab } from "components/Event/Corporate/Tabs/EventCorporateInvestorProfilesTab";
import { EventCorporateFeedbacksTab } from "components/Event/Corporate/Tabs/EventCorporateFeedbacksTab";
import { useEventFeedbacksQuery } from "queries/useEventFeedbacksQuery";
import { EventCorporateInvitationStatusTab } from "./Tabs/EventCorporateInvitationStatusTab";
import { useCheckEventAccess } from "components/Event/useCheckEventAccess";
import { Event } from "common/event/event.types";
import { Loader } from "@ic-anywhere/ic-components";
import { useTrackOnDisplayPage } from "components/common/event.tracking";
import { features } from "utils/logger/features";

export const EventDetailCorporate: React.FC = () => {
  const { id: eventId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const accessCheck = useCheckEventAccess(eventId);
  useTrackOnDisplayPage(features.eventDetailsRoadshowDisplay);
  const { data: eventDetail, isLoading } = useGetEventDetailQuery(eventId, accessCheck === "access");
  const { data: feedbacks } = useEventFeedbacksQuery(eventId);

  if (accessCheck === "not_access") {
    navigate(ROUTES.EVENTS_DASHBOARD, { replace: true });
  }

  if (accessCheck === "pending" || !eventDetail || isLoading) {
    return <Loader isVisible={true} />;
  }

  const eventName = eventDetail.event.name;
  const eventInfo: Event = {
    startDate: eventDetail.event.startDate,
    endDate: eventDetail.event.endDate,
    id: eventId,
    name: eventName,
    venue: eventDetail.event.venue,
  };
  return (
    <>
      <EventNavigation
        event={eventInfo}
        showInvestorProfiles={hasInvestorProfiles(eventDetail.event)}
        showFeedbacks={!isEmpty(feedbacks)}
      />
      <div className="container mt-4">
        <Routes>
          <Route path={"corporate"} element={<EventCorporateRoadshowTab eventDetail={eventDetail} />} />
          <Route path={"contact"} element={<EventCorporateContactsTab eventDetail={eventDetail} />} />
          <Route path={"status"} element={<EventCorporateInvitationStatusTab eventDetail={eventDetail} />} />
          <Route path={"investor"} element={<EventCorporateInvestorProfilesTab eventDetail={eventDetail} />} />
          <Route path={"feedback"} element={<EventCorporateFeedbacksTab eventDetail={eventDetail} />} />
        </Routes>
      </div>
    </>
  );
};

export default EventDetailCorporate;
